import React from "react";

import { Editor as TinyMceEditor } from "@tinymce/tinymce-react";

import { Alert } from "components";

export const TextEditor = ({ init, value, initialValue, onEditorChange }) => (
  <>
    <Alert
      description="<span class='paragraph-s-bold center'>This is an open editor. You are responsible for checking the content that you add to it. Copying and pasting will result in unexpected formatting and poor user experience.</span>"
      className="margin-bottom-100"
      type="red"
    />
    <TinyMceEditor
      initialValue={initialValue}
      onEditorChange={onEditorChange}
      value={value}
      init={{
        ...init,
        ...{
          height: 750,
          convert_urls: false,
          relative_urls: false,
          selector: "textarea",
          plugins: [
            "code importcss searchreplace autolink autosave save directionality visualblock image link table advlist lists wordcount textpattern noneditabl",
          ],
          menubar: "file edit view insert format tools table tc help",
          toolbar:
            "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor casechange removeformat | image link",
        },
      }}
    />
  </>
);
